/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable react/prop-types */
import React from 'react';
import { Modal } from 'antd';
import RiderForm from '../Rider/RiderForm';

const CorporateRiderCreateModal = ({
	open,
	email,
	corporateId,
	corporateName,
	loading,
	onCancel,
	onCreate,
}) => {
	const selectedCorporate = {
		id: corporateId,
		name: corporateName,
	};

	const handleSave = (values) => {
		onCreate({
			...values,
			email,
			corporateId,
		});
	};

	return (
		<Modal
			open={open}
			title='Create rider'
			onCancel={onCancel}
			footer={null}
			destroyOnClose
			width={520}>
			<RiderForm
				onSave={handleSave}
				onSaveFailed={() => {}}
				onCancel={onCancel}
				onDirty={() => {}}
				unsavedChanges={false}
				fileList={[]}
				setFileList={() => {}}
				handleUpload={(callback, values) => callback(values, null)}
				uploading={loading}
				setIsFileChosen={() => {}}
				corporates={{ corporatesList: corporateId ? [selectedCorporate] : [] }}
				corporatesLoading={false}
				initialValues={{ email, corporateId }}
				fixedEmail
				fixedCorporate
				hideProfilePicture
				disableSubmitUntilDirty={false}
				submitButtonText='Save'
				submitLoading={loading}
				compactActions
			/>
		</Modal>
	);
};

export default CorporateRiderCreateModal;
